import PropTypes from 'prop-types';
import { Check as CheckIcon } from '@mui/icons-material';
import { ToggleButton } from '@mui/material';

export const TOGGLE_BUTTON_VARIANTS = {
  DEFAULT: 'default',
  LIGHT: 'light',
};

export const CheckToggleButton = ({
  disabled = false,
  label,
  value = '',
  variant = TOGGLE_BUTTON_VARIANTS.LIGHT,
  hideIcon = false,
  backgroundColor = null,
  textColor = null,
  sx = {},
  ...other
}) => (
  <ToggleButton
    aria-label={label}
    disabled={disabled}
    value={value}
    variant={variant}
    disableRipple
    sx={{
      position: 'relative',
      border: '1px solid',
      borderColor: 'grey.5',
      color: 'primary.main',
      textTransform: 'none',
      '&.Mui-selected': {
        backgroundColor: backgroundColor || 'primary.5',
        outline: '1px solid',
        outlineColor: 'primary.main',
        outlineOffset: '-1px',
        color: textColor || 'primary.main',
        zIndex: 2,
        '&:hover': {
          backgroundColor: '#e1e1fa',
        },
      },
      '&:hover, &:focus': {
        backgroundColor: '#e1e1fa',
        zIndex: 1,
      },
      '&:focus': {
        borderColor: 'grey.60',
        outline: '2px solid',
        outlineColor: 'grey.60',
        outlineOffset: '-1px',
        zIndex: 1,
      },
      ...sx,
    }}
    {...other}
  >
    {other.selected && !hideIcon && (<CheckIcon fontSize="1.6rem" sx={{ marginRight: 1 }} />)}
    {label}
  </ToggleButton>
);

CheckToggleButton.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  variant: PropTypes.oneOf([
    TOGGLE_BUTTON_VARIANTS.DEFAULT,
    TOGGLE_BUTTON_VARIANTS.LIGHT,
  ]),
  hideIcon: PropTypes.bool,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  sx: PropTypes.shape({}),
};
